import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => {
  return {
    wrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      overflow: 'hidden'
    },

    tag: {
      display: 'inline-block',
      marginRight: token.marginXXS,
      marginBottom: token.marginXXS / 2
    }
  }
})
